import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getProductQna } from '../../api/productQna'
import { format } from 'date-fns'
import { ReplyRounded } from '../Badge'
import { BtnGrayRounded } from '../Button'
import { NoReviewContainer, NoReviewOuter, NoReviewInner } from './ProductDetailReviews'
import { useCommonContext } from '../provider/CommonProvider'
import { useMyContext } from '../provider/MyProvider'
import { ProductDetailBaseInfo, ProductDetailType } from '../../@types/product'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { useAppContext } from '../provider/AppProvider'

type QnaData = {
  items: []
  totalCount: number
}

interface ProductDetailQnaProps {
  product: ProductDetailType
  productItem?: ProductDetailBaseInfo
}

// 이미지 경로
const imgURL = '/images'

const ProductDetailQna = ({ productItem, product }: ProductDetailQnaProps) => {
  const navigate = useNavigate()
  const { isAppView } = useAppContext()
  const { setIsLottie, setIsLogin, hasAccessToken } = useCommonContext()
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()

  const [qnaData, setQnaData] = useState<QnaData>()
  const [qnaCount, setQnaCount] = useState<number[]>([])
  const [qnaPage, setQnaPage] = useState<number>(1)
  const [checkLoading, setCheckLoading] = useState<boolean>(false)
  const [qnaDrop, setQnaDrop] = useState<number | null>(null)

  const handleQnaClick = () => {
    if (hasAccessToken) {
      if (isAppView) {
        RNPostMessage(AFWebLinkType.moveToLink, {
          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/productQnaWrite?productNo=${productItem?.productNo}&productName=${productItem?.productName}&brandName=${product.brand?.name}&imgSrc=${productItem?.imageUrls[0]}`,
        })
      } else {
        navigate(`/productQnaWrite`, {
          state: {
            productNo: productItem?.productNo,
            productName: productItem?.productName,
            brandName: product.brand?.name,
            imgSrc: productItem?.imageUrls[0],
          },
        })
      }
    } else {
      setIsToast(true)
      setToastMessage('로그인이 필요한 서비스입니다.')
      setToastBtnMessage('로그인')
      setToastEvent(() => () => setIsLogin(true))
    }
  }

  useEffect(() => {
    if (productItem?.productNo) {
      getProductQna({
        pageNumber: qnaPage,
        pageSize: 10,
        productNo: productItem?.productNo || 0,
      }).then((res) => {
        setQnaData(res.data)
        const pageCount = Math.floor(res.data.items.length / 10) === 0 ? 1 : Math.floor(res.data.items.length / 10) + 1
        setQnaCount(Array.from({ length: pageCount }, (_, i) => i + 1))
        setIsLottie(false)
        setCheckLoading(true)
      })
    }
  }, [productItem, qnaPage])

  useEffect(() => {
    if (checkLoading) {
      getProductQna({
        pageNumber: qnaPage,
        pageSize: 10,
        productNo: productItem?.productNo || 0,
      }).then((res: any) => {
        setQnaData(res)
        setIsLottie(false)
      })
    }
  }, [qnaPage, checkLoading, productItem?.productNo])

  return (
    <div className='product_detail_qa'>
      <p className='title'>상품 Q&A</p>
      <div className='contents'>
        <p className='title'>상품 문의하기</p>
        <p>상품에 대한 궁금하신 내용을 문의해주세요.</p>
        <p>주문/배송 문의는 1:1문의로 문의해주세요.</p>
        <BtnGrayRounded className='btn_qna' onClick={handleQnaClick}>
          문의 작성하기
        </BtnGrayRounded>
      </div>
      <div className='list'>
        <p className='title'>문의 {qnaData?.items?.length || 0}건</p>
        <div className='contents'>
          <ul>
            {!qnaData?.items || qnaData?.items?.length === 0 ? (
              <NoReviewContainer>
                <NoReviewOuter>
                  <img src='/images/empty_logo.png' alt='' />
                  <NoReviewInner style={{ fontSize: '16px', lineHeight: '24px' }}>
                    작성한 문의가 없습니다.
                  </NoReviewInner>
                </NoReviewOuter>
              </NoReviewContainer>
            ) : (
              qnaData?.items?.map((el: any, index: number) => (
                <li key={el.inquiryNo}>
                  <div className='question' onClick={() => setQnaDrop(qnaDrop === index ? null : index)}>
                    <div className='q_txt_wrap'>
                      <ReplyRounded isreply={`${el.replied ? 'true' : 'false'}`}>
                        {el.replied ? '답변완료' : '답변대기'}
                      </ReplyRounded>
                      <i></i>
                      <span className='writer'>{el?.nickName}</span>
                      <i></i>
                      <span className='date'>{format(new Date(el.registerYmdt), 'yyyy. M. d')}</span>
                      <p>
                        <span>Q</span> {el.content}
                      </p>
                    </div>
                    <img src={`${imgURL}/icon_arrow_${qnaDrop === index ? 'up' : 'down'}.svg`} alt='' />
                  </div>
                  {el.answers?.length > 0 && qnaDrop === index && (
                    <div className='answer'>
                      <p>
                        <span>A</span> {el.answers[0]?.content}
                      </p>
                      <p className='date'>{format(new Date(el.answers[0].registerYmdt), 'yyyy. M. d')}</p>
                    </div>
                  )}
                </li>
              ))
            )}
          </ul>

          {qnaCount.length > 1 && (
            <div className='pagination'>
              <button>
                <img src={`${imgURL}/icon_arrow_prev.svg`} alt='' />
              </button>
              {qnaCount.map((el: any) => (
                <button
                  key={el}
                  className={qnaPage === el ? 'on' : ''}
                  onClick={() => {
                    setQnaPage(el)
                    if (el !== 1) {
                      setIsLottie(true)
                    }
                  }}
                >
                  {el}
                </button>
              ))}
              <button>
                <img src={`${imgURL}/icon_arrow_next.svg`} alt='' />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductDetailQna
